import React from 'react'

export const westVirginiaSetupVars = {
  siteId: 'westvirginia',
  pathPrefix: '/wv',
  menuHeader: "Discover West Virginia's Solution for:",
  appUrl: 'https://wv.headed2.com',
  logoImg: '/images/assets/west_virginia/horizontal/dark.svg',
  headerTitle: `The West Virginia CareerExplorer is a system designed for West Virginia`
}
